import Vue from "vue";
import tailwindConfig from "#tailwind-config";

// Expose Tailwind configuration file
Vue.prototype.$tailwindConfig = tailwindConfig;
